// userActions.js

import { REQUEST_DEPARTMENT_LIST, REQUEST_DEPARTMENT_LIST_ERROR, REQUEST_DEPARTMENT_LIST_SUCCESS, REQUEST_HOSPITAL_LIST, REQUEST_HOSPITAL_LIST_ERROR, REQUEST_HOSPITAL_LIST_SUCCESS, REQUEST_LOCATION_LIST, REQUEST_LOCATION_LIST_ERROR, REQUEST_LOCATION_LIST_SUCCESS, REQUEST_PROMOTION_LIST, REQUEST_PROMOTION_LIST_ERROR, REQUEST_PROMOTION_LIST_SUCCESS } from './Constant';

export const fetchDepartmentList = (searchDept) => ({
    type: REQUEST_DEPARTMENT_LIST,
    searchDept : searchDept
});
  
export const fetchDepartmentListSuccess = (department) => ({
    type: REQUEST_DEPARTMENT_LIST_SUCCESS,
    payload: department,
});
  
export const fetchDepartmentListFailure = (error) => ({
    type: REQUEST_DEPARTMENT_LIST_ERROR,
    payload: error,
});
  
export const fetchLocationList = (searchlocation) => ({
    type: REQUEST_LOCATION_LIST,
    searchlocation : searchlocation
});
  
export const fetchLocationListSuccess = (location) => ({
    type: REQUEST_LOCATION_LIST_SUCCESS,
    payload: location,
});
  
export const fetchLocationListFailure = (error) => ({
    type: REQUEST_LOCATION_LIST_ERROR,
    payload: error,
});
  

export const fetchHospitalList = (searchHospital) => ({
    type: REQUEST_HOSPITAL_LIST,
    searchHospital : searchHospital
});
  
export const fetchHospitalListSuccess = (hospital) => ({
    type: REQUEST_HOSPITAL_LIST_SUCCESS,
    payload: hospital,
});
  
export const fetchHospitalListFailure = (error) => ({
    type: REQUEST_HOSPITAL_LIST_ERROR,
    payload: error,
});
  
export const fetchPromotionsList = () => ({
    type: REQUEST_PROMOTION_LIST,
});

export const fetchPromotionsListSuccess = (promotions) => ({
    type: REQUEST_PROMOTION_LIST_SUCCESS,
    payload: promotions,
});
  
export const fetchPromotionsListFailure = (error) => ({
    type: REQUEST_PROMOTION_LIST_ERROR,
    payload: error,
});